import getWarehouseRules from './warehouse';

export default function getRentalWarehouseRules(configuration) {
  const baseRules = getWarehouseRules(configuration);

  return {
    ...baseRules,
    height: {
      default: 4.7,
      min: 4.7,
      max: 7,
      values: [4.7, 7],
    },
    hiddenMenuItems: ['colors'],
    rainGutter: {
      disabled: true,
      fixedValue: true,
    },
  };
}
